import React, { FC } from 'react';

import {
	EV_ICON_BUTTON_TYPES,
	EvFlexColumn,
	EvFlexRow,
	EvIconButton,
	X
} from '@evinced-private/ui-common';

import { REMOVE_BUTTON_AREA_HEIGHT, REMOVE_BUTTON_KEY } from './ScopeRuleRow.constants';
import { IScopeRuleRowLayoutProps } from './ScopeRuleRow.types';

/**
 * Shared layout template for a single scope rule row: an action control, a value
 * control, and a remove button. Each rule type (URL, issue types, issue
 * severities) supplies its own controls via the `actionControl` and
 * `valueControl` slots while sharing this layout.
 */
export const ScopeRuleRow: FC<IScopeRuleRowLayoutProps> = ({
	actionControl,
	valueControl,
	removeButtonTitle,
	onRemove
}) => (
	<EvFlexRow align="START" gap="MEDIUM" width="100%">
		<EvFlexRow align="START" gap="MEDIUM">
			<EvFlexColumn>{actionControl}</EvFlexColumn>
			<EvFlexColumn>{valueControl}</EvFlexColumn>
		</EvFlexRow>
		<EvFlexRow align="CENTER" justify="CENTER" width="auto" height={REMOVE_BUTTON_AREA_HEIGHT}>
			<EvIconButton
				key={REMOVE_BUTTON_KEY}
				icon={X}
				type={EV_ICON_BUTTON_TYPES.GHOST}
				ariaLabel={removeButtonTitle}
				onClick={onRemove}
			/>
		</EvFlexRow>
	</EvFlexRow>
);
